<template>
    <pagamentos
        :dataServicos="obterDataServicos()"
        rotaListagem="Gescon_Gestores_Pagamentos"
        rotaDetalhar="Gescon_Gestores_Pagamentos_Detalhar"
    ></pagamentos>
</template>

<script>
import Pagamentos from '@/app/gescon/pagamentos/Pagamentos2'
import PagamentosServicos from './PagamentosServicos'

export default {
    methods: {
        obterDataServicos() {
            return PagamentosServicos
        }
    },

    components: {
        Pagamentos
    }
}
</script>
